var _jsxFileName = "/codebuild/output/src1346489397/src/bitbucket.org/newyuinc/adc-polaris-web/src/hooks/useAuth.tsx";
import React, { useCallback, useEffect, useState } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { AppLicensingVerdict, AppRecognitionVerdict } from 'Constants';
import { RichText } from 'Components/utility';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import { setCountryRedirectUrl } from 'Utilities/dataHelpers';
import { getDifferenceInMinutesFromNow } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import { logout } from 'Utilities/session';
import { getObject, removeObject, setObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
const translationsKeys = {
  login: {
    lockoutMessageTitleKey: 'Login.modals.signInErrors.accountLocked',
    lockoutMessageSubtitleKey: 'Login.modals.signInErrors.accountLockedPeriod',
    authErrorTitleKey: 'Login.modals.signInErrors.loginFailure',
    authErrorAttemptsRemainingKey: 'Login.modals.signInErrors.attemptsRemaining',
    authErrorLockedKey: 'Login.modals.signInErrors.accountWillBeLocked'
  },
  changepassword: {
    lockoutMessageTitleKey: 'ChangePassword.microcopy.lockoutBanner.messageItem_1',
    lockoutMessageSubtitleKey: 'ChangePassword.microcopy.lockoutBanner.messageItem_2',
    authErrorTitleKey: 'ChangePassword.modals.changePasswordErrors.attemptsRemainingError.title',
    authErrorAttemptsRemainingKey: 'ChangePassword.modals.changePasswordErrors.attemptsRemainingError.message',
    authErrorLockedKey: 'ChangePassword.modals.changePasswordErrors.noAttemptsRemainingError.message'
  }
};
const useAuth = type => {
  const [isLocked, setIsLocked] = useState(false);
  const [lockoutMessage, setLockoutMessage] = useState('');
  const [lockoutSubmessage, setlockoutSubmessage] = useState('');
  const [translationKeys, setTranslationKeys] = useState({
    lockoutMessageTitleKey: '',
    lockoutMessageSubtitleKey: '',
    authErrorTitleKey: '',
    authErrorAttemptsRemainingKey: '',
    authErrorLockedKey: ''
  });
  useEffect(() => {
    if (type) {
      const translationKeys = translationsKeys[type];
      setTranslationKeys(translationKeys);
    }
  }, [type]);
  const handleLockoutError = error => {
    var _error$response, _error$response2;
    const attemptsResetAfter = Number((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.headers['x-attempts-reset-after']);
    const attemptsResetAt = Number((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.headers['x-attempts-reset-at']);
    showLockoutMessage(attemptsResetAt, attemptsResetAfter);
  };
  const handleWrongRegionError = useCallback((error, showApiErrorModal, handleSubmit) => {
    var _error$response3;
    const redirectUrl = (_error$response3 = error.response) === null || _error$response3 === void 0 || (_error$response3 = _error$response3.headers) === null || _error$response3 === void 0 ? void 0 : _error$response3['x-api-url'];
    if (!redirectUrl) {
      showApiErrorModal();
      return;
    }
    setCountryRedirectUrl(redirectUrl);
    handleSubmit();
  }, []);
  const showLockoutMessage = useCallback((attemptsResetAt, attemptsResetAfter) => {
    const {
      time,
      difference
    } = getDifferenceInMinutesFromNow(attemptsResetAt);
    if (difference < 0) {
      return;
    }
    setIsLocked(true);
    setLockoutMessage(i18n.t(translationKeys.lockoutMessageTitleKey));
    setlockoutSubmessage(i18n.t(translationKeys.lockoutMessageSubtitleKey, {
      time
    }));
    const lockoutInterval = setInterval(() => {
      const {
        time,
        difference
      } = getDifferenceInMinutesFromNow(attemptsResetAt);
      if (difference < 0) {
        clearInterval(lockoutInterval);
        setLockoutMessage('');
        setlockoutSubmessage('');
        setIsLocked(false);
        removeObject('loginLockout');
      } else {
        setlockoutSubmessage(i18n.t(translationKeys.lockoutMessageSubtitleKey, {
          time
        }));
      }
    }, 1000);
    setObject('loginLockout', {
      attemptsResetAt,
      lockoutInterval,
      attemptsResetAfter
    });
  }, [translationKeys.lockoutMessageSubtitleKey, translationKeys.lockoutMessageTitleKey]);
  useEffect(() => {
    const loginLockout = getObject('loginLockout');
    if (loginLockout) {
      showLockoutMessage(loginLockout.attemptsResetAt, loginLockout.attemptsResetAfter);
    }
    return () => {
      const loginLockout = getObject('loginLockout');
      if (loginLockout) {
        clearInterval(loginLockout.lockoutInterval);
      }
    };
  }, [showLockoutMessage]);
  const showLoginFailure = useCallback((attemptsRemaining = -1, attemptsResetAfter, attemptsResetAt, onCloseAfterLockout, onClose) => {
    const modalProps = {
      details: /*#__PURE__*/React.createElement(Stack, {
        gap: "$4",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 152,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(Text, {
        testID: translationKeys.authErrorTitleKey,
        nativeID: translationKeys.authErrorTitleKey,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 153,
          columnNumber: 13
        }
      }, i18n.t(translationKeys.authErrorTitleKey)), attemptsRemaining >= 0 ? /*#__PURE__*/React.createElement(Stack, {
        display: "inline",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(Text, {
        testID: translationKeys.authErrorAttemptsRemainingKey,
        nativeID: translationKeys.authErrorAttemptsRemainingKey,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 17
        }
      }, i18n.t(translationKeys.authErrorAttemptsRemainingKey, {
        count: attemptsRemaining
      })), attemptsResetAfter ? /*#__PURE__*/React.createElement(Text, {
        testID: translationKeys.authErrorLockedKey,
        nativeID: translationKeys.authErrorLockedKey,
        fontWeight: "$bodyBase.medium",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170,
          columnNumber: 19
        }
      }, i18n.t(translationKeys.authErrorLockedKey, {
        time: attemptsResetAfter,
        duration: attemptsResetAfter
      })) : null) : null),
      testID: 'Auth'
    };
    modalProps.onClose = () => {
      onClose && onClose();
    };
    if (attemptsResetAfter && attemptsResetAt) {
      modalProps.onClose = () => {
        showLockoutMessage(attemptsResetAt, attemptsResetAfter);
        onCloseAfterLockout && onCloseAfterLockout();
      };
    }
    store.dispatch({
      type: SHOW_MODAL,
      modalProps
    });
  }, [showLockoutMessage, translationKeys.authErrorAttemptsRemainingKey, translationKeys.authErrorLockedKey, translationKeys.authErrorTitleKey]);
  const handleLoginError = (error, onCloseAfterLockout, onClose) => {
    var _error$response4;
    if (((_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data.details) === 'Authorization.isRequired') {
      logout();
      return;
    }
    if (error.response && error.response.headers['x-attempts-remaining']) {
      const attemptsRemaining = Number(error.response.headers['x-attempts-remaining']);
      const attemptsResetAt = error.response.headers['x-attempts-reset-at'] ? Number(error.response.headers['x-attempts-reset-at']) : 0;
      const attemptsResetAfter = error.response.headers['x-attempts-reset-after'] ? Number(error.response.headers['x-attempts-reset-after']) / 60 : 0;
      showLoginFailure(attemptsRemaining, attemptsResetAfter, attemptsResetAt, onCloseAfterLockout, onClose);
      return;
    }
    showLoginFailure();
  };
  const showHcpError = () => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 249,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.blockHCPUser.body",
          text: i18n.t('Global.modals.blockHCPUser.body', {
            appName: i18n.t('Global.appNames.libreView')
          }),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 250,
            columnNumber: 13
          }
        })),
        testID: 'Auth'
      }
    });
  };
  const showAndroidIntegrityErrorMessage = (key, notifyAppData) => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        onClose: () => notifyApp('adc-webview:api-integrity', notifyAppData),
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 284,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          text: i18n.t(key),
          testID: key,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 285,
            columnNumber: 13
          }
        }))
      }
    });
  };
  const handleAndroidIntegrityError = error => {
    var _error$response5, _error$response6, _error$response7, _error$response8, _error$response9, _error$response0;
    const verdictDeviceRecognition = (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.headers['x-verdict-device-recognition'];
    const verdictAppRecognition = (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.headers['x-verdict-app-recognition'];
    const verdictAppLicensing = (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.headers['x-verdict-app-licensing'];
    const verdictStatus = (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : _error$response8.headers['x-verdict-status'];
    const deviceActivityLevel = (_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : _error$response9.headers['x-verdict-device-activity-level'];
    const notifyAppData = {
      errors: (_error$response0 = error.response) === null || _error$response0 === void 0 ? void 0 : _error$response0.data.errors,
      verdictDeviceRecognition,
      verdictAppRecognition,
      verdictAppLicensing,
      verdictStatus,
      deviceActivityLevel
    };
    if (verdictAppRecognition === AppRecognitionVerdict.UNRECOGNIZED_VERSION) {
      showAndroidIntegrityErrorMessage('Global.modals.androidIntegrityErrors.versionNotSupported', notifyAppData);
      return;
    }
    if (verdictAppLicensing === AppLicensingVerdict.UNLICENSED) {
      showAndroidIntegrityErrorMessage('Global.modals.androidIntegrityErrors.reinstallApp', notifyAppData);
      return;
    }

    // TODO: The following cases are currently unhandled (app terminates with no error message):
    // - verdictStatus: REQUEST_HASH_TOO_LONG, APP_NOT_INSTALLED, APP_UID_MISMATCH, INTERNAL_ERROR, CLOUD_PROJECT_NUMBER_IS_INVALID, TOO_MANY_REQUESTS, NO_ERROR
    // - appRecognitionVerdict, deviceRecognitionVerdict, appLicensingVerdict: UNEVALUATED or empty
    // - deviceRecognitionVerdict: array does not contain MEETS_DEVICE_INTEGRITY
    // - deviceActivityLevel: LEVEL_4, LEVEL_1, LEVEL_2, LEVEL_3
    // -  Review if future requirements change.
    notifyApp('adc-webview:api-integrity', notifyAppData);
  };
  const showDefaultLoginError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.loginFailure'),
        testID: 'Auth'
      }
    });
  }, []);
  const showCountryRegionError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.regionDoesNotMatch'),
        testID: 'Auth'
      }
    });
  }, []);
  const showCountryNotSupportedError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.countryNotSupported'),
        testID: 'Auth'
      }
    });
  }, []);
  const showAppUpgradeError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        header: i18n.t('Login.modals.updateApp.title'),
        details: /*#__PURE__*/React.createElement(Text, {
          type: "$bodyBase.default",
          nativeID: "Login.modals.updateApp.title",
          testID: "Login.modals.updateApp.title",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 369,
            columnNumber: 11
          }
        }, i18n.t('Login.modals.updateApp.body')),
        primaryAction: {
          label: i18n.t('Global.microcopy.common.update'),
          onPress: () => {
            const {
              androidAppURL,
              iosAppURL
            } = store.getState().config;
            const {
              osType
            } = store.getState().env;
            const storeLink = osType === 'iOS' ? iosAppURL : androidAppURL;
            if (storeLink) {
              window.open(storeLink);
            }
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        testID: 'Auth'
      }
    });
  }, []);
  const showSessionManagementError = useCallback(onForceSignIn => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 405,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.supportNewNSInstanceLogin.body",
          text: i18n.t('Global.modals.supportNewNSInstanceLogin.body', {
            appName: i18n.t('Global.appNames.libreView')
          }),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 406,
            columnNumber: 13
          }
        })),
        primaryAction: {
          label: i18n.t('Global.microcopy.common.okCap'),
          onPress: () => {
            onForceSignIn();
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        testID: 'Auth'
      }
    });
  }, []);
  const showTokenExpirationError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 441,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.linkNotValid.title",
          text: i18n.t('Global.modals.linkNotValid.title'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 442,
            columnNumber: 13
          }
        }), /*#__PURE__*/React.createElement(Text, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 446,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.linkNotValid.body'))),
        testID: 'Auth'
      }
    });
  }, []);
  const showForgotPasswordBlockedMessage = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 459,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.youReached",
          nativeID: "ForgotPassword.modals.forgotErrors.youReached",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 460,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.youReached')), /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.consider",
          nativeID: "ForgotPassword.modals.forgotErrors.consider",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 466,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.consider'))),
        testID: 'Auth'
      }
    });
  }, []);
  const showForgotPasswordConfirmationMessage = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 484,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.sentInstructions",
          nativeID: "ForgotPassword.modals.forgotErrors.sentInstructions",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 485,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.sentInstructions')), /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.notSeeingEmail",
          nativeID: "ForgotPassword.modals.forgotErrors.notSeeingEmail",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 491,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.notSeeingEmail'))),
        testID: 'Auth'
      }
    });
  }, []);
  return {
    handleLoginError,
    handleLockoutError,
    handleWrongRegionError,
    showHcpError,
    isLocked,
    lockoutMessage,
    lockoutSubmessage,
    showSessionManagementError,
    showTokenExpirationError,
    showForgotPasswordBlockedMessage,
    showForgotPasswordConfirmationMessage,
    showCountryRegionError,
    showCountryNotSupportedError,
    handleAndroidIntegrityError,
    showDefaultLoginError,
    showAppUpgradeError
  };
};
export default useAuth;